export {
  assignDevice,
  createDevice,
  createDeviceFileGroup,
  deleteDevice,
  deleteDeviceFile,
  deleteDeviceFileGroup,
  finalizeDeviceFile,
  getDevice,
  getMyDevices,
  listDeviceFileGroups,
  listDevices,
  reorderDeviceFile,
  requestDeviceFileUploadUrl,
  searchDevicesByImei,
  updateDevice,
  updateDeviceFileGroup,
} from '@uchat-team-management/shared';
export type {
  AssignDeviceBody,
  AssignmentHistoryItem,
  CreateDeviceBody,
  CreateDeviceFileGroupBody,
  DeviceFile,
  DeviceFileGroup,
  DeviceListItem,
  DeviceOs,
  DeviceRow,
  DeviceStatus,
  FinalizeFileBody,
  ImeiSearchMatch,
  MyDevice,
  SupportedContentType,
  UpdateDeviceBody,
  UploadUrlBody,
} from '@uchat-team-management/shared';

import { apiCall } from '@/lib/api';
import {
  type SupportedContentType as ContentType,
  finalizeDeviceFile,
  requestDeviceFileUploadUrl,
} from '@uchat-team-management/shared';

/** Three-step device file upload: presign → PUT to storage → finalize row. */
export const uploadDeviceFile = async (deviceId: string, groupSlug: string, file: File) => {
  const contentType = file.type as ContentType;
  const urlResp = await apiCall(requestDeviceFileUploadUrl, {
    params: { deviceId },
    body: { groupSlug, contentType, filename: file.name, sizeBytes: file.size },
  });
  const putRes = await fetch(urlResp.data.presignedUrl, {
    method: 'PUT',
    headers: { 'Content-Type': contentType },
    body: file,
  });
  if (!putRes.ok) throw new Error('Storage upload failed');
  return apiCall(finalizeDeviceFile, {
    params: { deviceId },
    body: {
      groupSlug,
      storagePath: urlResp.data.storagePath,
      contentType,
      filename: file.name,
      sizeBytes: file.size,
    },
  });
};
